import {createSlice, createAsyncThunk} from "@reduxjs/toolkit";
import {get, post} from "../../network/axiosServices";


const initialState = {
    loading: false,
    posts: [],
    error: '',
}

export const fetchEquipment = createAsyncThunk("fetchEquipment", (params) => {
    return get(params);
});


const postSlice = createSlice({
    name: 'equipment',
    initialState,
    extraReducers: builder => {
        builder.addCase(fetchEquipment.pending, (state) => {
            state.loading = true
            state.posts = []
            state.error = ''
        })
        builder.addCase(fetchEquipment.fulfilled, (state, action) => {
            state.loading = false
            state.posts = action.payload
            state.error = ''
        })
        builder.addCase(fetchEquipment.rejected, (state, action) => {
            state.loading = false
            state.posts = []
            state.error = action.error
        })

    }
})


export default postSlice.reducer
